import React, { FC } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { Container } from '../atoms/container';
import { Heading3 } from '../atoms/heading';
import { Paragraph } from '../atoms/paragraph';
import { SearchResult } from '../../../types/search';

const SearchListContainer = styled(Container)`
  position: absolute;
  top: 55px;
  right: 0;
  left: 0;
  bottom: 0;
  height: 80vh;
  overflow: scroll;
  border-radius: 4px;
`;

const SearchHitsList = styled.ul`
  list-style: none;
  ${({ theme }): string => theme.mixins.padding(1)};
  ${({ theme }): string => theme.mixins.margin({ hor: 1, ver: 0 })};
  background-color: #fff;
  border-radius: 4px;
`;

const SearchHitContainer = styled.li`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${({ theme }): string => theme.commons.colors.primary100};
`;

const SearchLink = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-direction: column;
`;

const SearchTitle = styled(Heading3)`
  color: ${({ theme }): string => theme.commons.colors.primary};
  ${({ theme }): string => theme.mixins.margin({ top: 3.5, bottom: 0 })};
`;

const SearchAbstract = styled(Paragraph)`
  ${({ theme }): string => theme.mixins.margin({ top: 1 })};
`;

interface SearchHitsProps {
  hits: SearchResult[];
}

export const SearchHits: FC<SearchHitsProps> = ({ hits }) => (
  <SearchListContainer>
    <SearchHitsList>
      {hits.map((hit) => (
        <SearchHitContainer key={hit.slug}>
          <SearchLink to={hit.slug}>
            <SearchTitle>{hit.title}</SearchTitle>
            <SearchAbstract>{hit.abstract}</SearchAbstract>
          </SearchLink>
        </SearchHitContainer>
      ))}
    </SearchHitsList>
  </SearchListContainer>
);
